import { render, staticRenderFns } from "./CardItemHospitalCollapse.vue?vue&type=template&id=2c35d527&scoped=true"
import script from "./CardItemHospitalCollapse.vue?vue&type=script&lang=js"
export * from "./CardItemHospitalCollapse.vue?vue&type=script&lang=js"
import style0 from "./CardItemHospitalCollapse.vue?vue&type=style&index=0&id=2c35d527&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35d527",
  null
  
)

export default component.exports